module.exports = __webpack_public_path__ + "img/arrow_drop_down_4.b050bb38.svg";